import { FC } from 'react';
import classnames from 'classnames';

import { trackFooterNavigationClick } from '../../../helpers/trackingHelpers';

import { FooterLink } from '../FooterLinkTypes';
import { SeoLinkComponent } from 'dibs-seo/exports/SeoLink';

import styles from './LinkColumnItem.scss';

type Props = FooterLink & {
    isLegalLink?: boolean;
};

const LinkColumnItem: FC<Props> = ({
    target,
    trackingLabel,
    href,
    dataTn,
    message,
    badgeText,
    isLegalLink,
    isLinkable,
}) => {
    const doNotShowPrivacyPolicyAlerts = true;
    const shouldShowBadge = !!badgeText && !doNotShowPrivacyPolicyAlerts;

    return (
        <li className={classnames(styles.item, { [styles.isLegalLink]: !!isLegalLink })}>
            {href ? (
                <SeoLinkComponent
                    linkData={{
                        path: href,
                        isLinkable,
                    }}
                    target={target}
                    onClick={() => trackFooterNavigationClick({ label: trackingLabel })}
                    dataTn={dataTn}
                    buyerLinkType="contrastLinkLight"
                >
                    {message}
                    {shouldShowBadge && <div>{badgeText}</div>}
                </SeoLinkComponent>
            ) : (
                message
            )}
        </li>
    );
};

LinkColumnItem.defaultProps = {
    isLinkable: true,
};

export default LinkColumnItem;
